import * as yup from 'yup';
import { EmployeeNameSchema, IName, ITimeosUser } from '../../common';
import {
  EmployeeBaseDataSchema,
  IEmployeeBaseData,
  IUpdateEmployeeBaseData,
  UpdateEmployeeBaseDataSchema,
} from './employee-base-data';

export const EmployeeSchema = yup.object({
  identifier: yup
    .string()
    .matches(/^[0-9]{1,6}$/, { message: 'format' })
    .required('required'),
  name: EmployeeNameSchema.required(),
  employeeBaseData: EmployeeBaseDataSchema.notRequired(),
  nursingHomeId: yup.string().notRequired(),
  timeosUserId: yup.number().notRequired(),
  //TODO extend it with contract data once it will be required
});

export interface IEmployee {
  id: string;
  identifier: string;
  name: IName;
  employeeBaseData?: IEmployeeBaseData;
  nursingHomeId?: string;
  timeosUser?: ITimeosUser;
}

export interface ICreateEmployee {
  identifier: string;
  name: IName;
  employeeBaseData?: IEmployeeBaseData;
  nursingHomeId?: string;
  timeosUser?: ITimeosUser;
}

export const UpdateEmployeeSchema = yup.object({
  id: yup.string().required(),
  identifier: yup
    .string()
    .matches(/^[0-9]{1,6}$/, { message: 'format' })
    .optional(),
  name: EmployeeNameSchema.optional().default(undefined),
  employeeBaseData: UpdateEmployeeBaseDataSchema.optional().default(undefined),
});

export interface IUpdateEmployee {
  id: string;
  identifier?: string;
  name?: IName;
  employeeBaseData?: IUpdateEmployeeBaseData;
}
